<template>
  <div>
    <div class="main">
      <el-card
        v-loading="loading"
        class="box-card margin-b-20">
        <div v-if="screen == 1">
          <p class="encabezado margin-b-30">
            <strong>Sube la factura en formato XML</strong> que valide la
            compra de tu
            cliente
          </p>
          <div class="margin-b-20">
            <el-upload
              :on-progress="onProgress"
              :on-change="onChange"
              :on-success="onSuccess"
              :on-error="onError"
              :on-exceed="onExceed"
              :headers="headers"
              :multiple="false"
              :show-file-list="false"
              :action="uploadURL"
              class="upload-demo"
              accept=".xml, .pdf, .jpg, .jpeg, .png"
              drag
            >
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                Suelta tu archivo aquí o
                <em>haz clic para cargar</em>
              </div>
            </el-upload>
          </div>
        </div>
        <div v-else-if="screen == 2">
          <p class="encabezado margin-b-30">
            Factura procesada
            <strong>correctamente</strong>
          </p>
          <div class="margin-b-20 text-center">
            <span class="circle"/>
          </div>
          <div class="margin-b-20 text-center">
            <span class="text-success">{{ invoicePath }}</span>
          </div>
          <div class="margin-b-30 text-center margin-l">
            <span class="text-success">
              Si deseas reemplazar la factura que subiste,
              <a
                href
                @click.prevent="screen = 1"
              >haz clic aquí.</a>
            </span>
          </div>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <!-- <router-link :to="{name:'promotions'}">
              <el-button>Atrás</el-button>
            </router-link>-->
          </el-col>
          <el-col
            :span="12"
            :push="12">
            <el-button
              :disabled="disableButton"
              type="primary"
              @click="goNext">Siguiente</el-button>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import MenuProfile from '@/components/_shared/main-menu.vue'
import Steps from '@/components/_shared/main-steps.vue'
import auth from '@/services/auth.service'

export default {
  name: 'Upload',
  components: {
    MenuProfile,
    Steps
  },
  data () {
    return {
      loading: false,
      screen: 1,
      disableButton: true,
      uploadURL: process.env.API_URL + 'upload-file',
      headers: {
        authorization: 'Bearer ' + auth.token()
      }
    }
  },
  computed: {
    invoicePath: {
      get () {
        return this.$store.getters['app/order'].invoicePath
      },
      set (file) {
        this.$store.dispatch('app/order', {invoicePath: file})
      }
    }
  },
  mounted () {
    if (this.invoicePath) {
      this.screen = 2
      this.disableButton = false
    }
  },
  methods: {
    onProgress (event, file, fileList) {
      this.loading = true
    },
    onExceed (event, file, fileList) {
      // console.log(event, file, fileList)
    },
    onChange (file, fileList) {
      // console.log(file, fileList)
    },
    onSuccess (response, file, fileList) {
      this.invoicePath = response.path
      this.loading = false
      this.screen = 2
      this.disableButton = false
    },
    onError (err, file, fileList) {
      console.log(JSON.parse(err.message))

      let errorsCatalogue = {
        NOT_AVAILABLE_CODES: 'El distribuidor ya no tiene códigos disponibles para asignar.',
        NOT_AVAILABLE_CODES_FOR_REQUEST: `El distribuidor está tratando de registrar más codigos que los asignados.`,
        QUANTITY_NOT_MATCH: 'La cantidad de códigos no coincide con el numero de llantas reportadas',
        SOME_CODES_ARE_NOT_VALID: 'Algunos códigos enviados, son invalidos o no existen.',
        INVOICE_USED: 'La factura ya fue registrada.',
        INVALID_EXTENSION_FILE: 'La extensión del archivo es inválida.',
        INVALID_INVOICE_FORMAT: 'El formato de la factura no coincide con el estandar del SAT',
        CANCELED_INVOICE: 'La factura está reportada como cancelada ante el SAT.',
        REFUSED_INVOICE: 'La factura está reportada como rechazada ante el SAT.',
        EXPIRED_INVOICE: 'La fecha de la factura no corresponde al periodo de la promoción.',
        USED_INVOICE: 'La factura ya fue registrada.'
      }

      let e = JSON.parse(err.message)

      this.loading = false

      this.$message.error(errorsCatalogue[e.code] || 'Error en el servidor al procesar su petición' + e.code)
    },
    goNext () {
      this.$router.push('codes')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/invoice-form.vue